import * as Ant from "antd";

import React from "react";
import styled from "styled-components";

export function Menu({
  children,
  ...props
}: React.ComponentProps<typeof Ant.Menu>) {
  return <Ant.Menu {...props}>{children}</Ant.Menu>;
}

export namespace Menu {
  export const SubMenu = Ant.Menu.SubMenu;
  export const ItemGroup = Ant.Menu.ItemGroup;

  export function Item({
    children,
    ...props
  }: React.ComponentProps<typeof Ant.Menu.Item>) {
    return (
      <Ant.Menu.Item {...props}>
        <Item.Title>{children}</Item.Title>
      </Ant.Menu.Item>
    );
  }

  export namespace Item {
    export const Title = styled.span`
      font-weight: 500;
    `;
  }
}
